// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.appIcon {
  width: 1.5em;
  height: 1.5em;
}

.control__btn {
  position: absolute;
  bottom: 0.5em;
  right: 1.5em;
}

.btn_container {
  display: flex;
  gap: 2em;
  margin-bottom: 1em;
}
.btn_container.left {
  width: 100%;
  justify-content: flex-end;
}

.two-column-page__container {
  height: 100%;
  display: flex;
  position: relative;
  width: 100%;
}
.two-column-page__container .right-side {
  max-width: 50%;
  padding-left: 1%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.two-column-page__container .left-side {
  padding-right: 1%;
  border-right: 1px solid rgba(66, 108, 166, 0.1647058824);
  max-width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.two-column-page__container .save_btns {
  color: #567db8;
}
.two-column-page__container .save_btns button {
  margin-top: 10px;
  margin-left: 10px;
  font-weight: 400;
  color: #567db8;
  border: 0;
}
.two-column-page__container .save_btns button:disabled {
  color: rgba(86, 125, 184, 0.4117647059);
  background: rgba(218, 225, 236, 0.5411764706);
  cursor: default;
}
.two-column-page__container hr {
  border-top: 0.01px solid rgba(45, 109, 199, 0.3411764706);
  width: 100%;
  margin-left: 0;
  color: #426ba6;
}

.right-side-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.label {
  align-items: center;
}
.label_thin {
  color: #88a5cf;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  margin-right: 5px;
}
.label.underline {
  text-decoration: underline;
}
.label.autolabel {
  width: min-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
}

.autolabel label {
  width: min-content;
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: keep-all;
  white-space: nowrap; /* Запретить перенос текста по строчке */
  display: inline-block;
  width: auto;
}

.row {
  display: flex;
  align-items: baseline;
}

.labelWrap {
  white-space: nowrap;
}

.tac {
  text-align: center;
}

.project_form {
  height: 100%;
}

.list_container {
  width: 100%;
  height: 120px;
  overflow-x: hidden;
  background: #ffffff;
  margin-bottom: 5px;
  border: rgba(66, 108, 166, 0.5058823529);
}

.grid2_3 {
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr 1fr 1fr;
}

.grid2_5 {
  display: grid;
  grid-template: 0fr 0fr/1fr 1fr 1fr 1fr auto;
  width: 100%;
  column-gap: 10px;
}

.fdr {
  display: flex;
  flex-direction: row;
}

.flex_form {
  display: flex;
  flex-direction: column;
}

.flex_container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.fc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.hw100 {
  height: 100%;
  width: 100%;
  flex-grow: 1;
}

.fc {
  display: flex;
  align-items: center;
}
.fc .fi50 {
  flex-basis: 50%;
}
.fc .fi60 {
  flex-basis: 60%;
}
.fc .fi70 {
  flex-basis: 70%;
}

.fcc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nowrap {
  flex-wrap: nowrap;
}

.space-between {
  justify-content: space-between;
}

.jcsb {
  justify-content: space-between;
}

.jcsa {
  justify-content: space-around;
}

.jcc {
  justify-content: center;
}

.jcfe {
  justify-content: flex-end;
}

.jcfs {
  justify-content: flex-start;
}

.aic {
  align-items: center;
}

.aife {
  align-items: flex-end;
}

.aist {
  align-items: flex-start;
}

.aibl {
  align-items: baseline;
}

.aistr {
  align-items: stretch;
}

.fd {
  flex-direction: column;
}

.gap {
  gap: 1rem;
}

.gap2x {
  gap: 2rem;
}

.gap5 {
  gap: 5px;
}

.halfBasis {
  flex-basis: 50%;
}

.mba {
  margin-bottom: auto;
}

.mb {
  margin-bottom: 1rem;
}

.mb2x {
  margin-bottom: 2rem;
}

.pb {
  padding-bottom: 1rem;
}

.pt {
  padding-top: 1rem;
}

.pt2x {
  padding-top: 2rem;
}

.noShrink {
  flex-shrink: 0;
}

.g2 {
  gap: 2em;
}

.g1 {
  gap: 1em;
}

.g15 {
  gap: 1.5em;
}

.fGrow {
  flex-grow: 1;
}

.fShrink {
  flex-shrink: 2;
}

.h100 {
  height: 100%;
}

.hmax100 {
  max-height: 100%;
}

.w100 {
  width: 100%;
}

.wmax100 {
  max-width: 100%;
}

.overflowAuto {
  overflow: auto;
}

.overflowX {
  overflow-x: auto;
}

.overflowY {
  overflow-y: auto;
}

.overflowHidden {
  overflow: hidden;
}

.fcCol {
  display: flex;
  flex-direction: column;
}

.page_container {
  padding: 0 1%;
  padding-top: 5px;
  height: 100%;
}

.form_wrapper {
  height: 100%;
  width: 100%;
  min-width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: visible;
  position: relative;
}

.border_bottom_container {
  border-bottom: 1px solid rgba(66, 108, 166, 0.5058823529);
  width: 100%;
}

.imgPreview {
  width: 100%;
  min-width: 600px;
  height: 100%;
  padding: 1em 2em;
  padding-bottom: 3em;
  box-sizing: border-box;
}

.previewBox {
  width: 100%;
  height: auto;
  min-height: 250px;
  max-width: 920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 20px 20px;
  box-sizing: border-box;
  border: dashed 3px rgba(66, 108, 166, 0.368627451);
  border-radius: 10px;
  gap: 10px;
}

.previewBoxItem {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  object-fit: contain;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  width: 200px;
  height: 200px;
}

.previewBoxItem__del {
  position: absolute;
  top: 0;
  right: -4px;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: aliceblue;
  font-size: 18px;
  line-height: 18px;
  font-weight: 300;
  margin-top: -5px;
  cursor: pointer;
}

.previewBoxItem img {
  object-fit: cover;
}

.imgPreview__buttons {
  position: fixed;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  bottom: 10px;
  right: 5px;
}

.img-adding {
  border: 0;
}

.cropper_container {
  padding: 1em 2em;
  box-sizing: border-box;
}

.list {
  padding: 0;
  list-style: none;
}

.hideOverflow {
  overflow: hidden;
}

.scrollOverflow {
  overflow-y: scroll;
}

.centeredText {
  text-align: center;
}

.toBottom {
  margin-top: auto;
}

.mt {
  margin-top: 1rem;
}

.pl {
  padding-left: 1rem;
}

.scrollY {
  overflow-y: auto;
}

.fullWidth {
  width: 100%;
}

.zindex {
  z-index: 10000;
}

.hiddenEl {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);
}

.db {
  display: block;
}

.ml {
  margin-left: 1rem;
}
.ml2x {
  margin-left: 2rem;
}
.ml5x {
  margin-left: 5rem;
}
.mla {
  margin-left: auto;
}

.mr {
  margin-right: 1rem;
}
.mr2x {
  margin-right: 2rem;
}
.mr5x {
  margin-right: 5rem;
}
.mra {
  margin-right: auto;
}

.mta {
  margin-top: auto;
}

.dg {
  display: grid;
}

.bold {
  font-weight: bold;
}

.bordered {
  border: 1px solid rgba(66, 108, 166, 0.368627451);
}

.inputNoArrows::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}
.inputNoArrows::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}

.navItemDisabled {
  opacity: 0.5;
  cursor: default;
}

.largeModal {
  max-height: 90vh;
}
.largeModal .modal_form__child {
  flex-direction: column;
}

.padding5 {
  padding: 5px;
}

.br {
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,aAAA;AAEF;;AAAA;EACE,kBAAA;EACA,aAAA;EAEA,YAAA;AAEF;;AAAA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAGF;AAFE;EACE,WAAA;EACA,yBAAA;AAIJ;;AADA;EAEE,YAAA;EAIA,aAAA;EAEA,kBAAA;EACA,WAAA;AADF;AAIE;EACE,cAAA;EACA,gBAAA;EAMA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AAPJ;AAaE;EACE,iBAAA;EACA,wDAAA;EACA,eAAA;EAUA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;AApBJ;AAsBE;EACE,cAAA;AApBJ;AAqBI;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAnBN;AAoBM;EACE,uCAAA;EACA,6CAAA;EACA,eAAA;AAlBR;AAsBE;EACE,yDAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AApBJ;;AAuBA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;AApBF;;AAwBA;EACE,mBAAA;AArBF;AAsBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AApBJ;AAsBE;EACE,0BAAA;AApBJ;AAsBE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;AApBJ;;AAwBE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,wCAAA;EACA,qBAAA;EACA,WAAA;AArBJ;;AAwBA;EACE,aAAA;EACA,qBAAA;AArBF;;AAwBA;EACE,mBAAA;AArBF;;AAwBA;EACE,kBAAA;AArBF;;AAwBA;EACE,YAAA;AArBF;;AAwBA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,wCAAA;AAtBF;;AA0BA;EACE,aAAA;EACA,sCAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,2CAAA;EACA,WAAA;EACA,gBAAA;AAtBF;;AA0BA;EACE,aAAA;EACA,mBAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,sBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAtBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AArBF;;AAwBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;AArBF;AAwBE;EACE,eAAA;AAtBJ;AAwBE;EACE,eAAA;AAtBJ;AAwBE;EACE,eAAA;AAtBJ;;AA0BA;EACE,aAAA;EAEA,mBAAA;EACA,mBAAA;AAxBF;;AA0BA;EACE,iBAAA;AAvBF;;AAyBA;EACE,8BAAA;AAtBF;;AAwBA;EACE,8BAAA;AArBF;;AAuBA;EACE,6BAAA;AApBF;;AAsBA;EACE,uBAAA;AAnBF;;AAqBA;EACE,yBAAA;AAlBF;;AAoBA;EACE,2BAAA;AAjBF;;AAmBA;EACE,mBAAA;AAhBF;;AAkBA;EACE,qBAAA;AAfF;;AAiBA;EACE,uBAAA;AAdF;;AAgBA;EACE,qBAAA;AAbF;;AAeA;EACE,oBAAA;AAZF;;AAcA;EACE,sBAAA;AAXF;;AAcA;EACE,SAAA;AAXF;;AAaA;EACE,SAAA;AAVF;;AAYA;EACE,QAAA;AATF;;AAWA;EACE,eAAA;AARF;;AAUA;EACE,mBAAA;AAPF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,mBAAA;AALF;;AAOA;EACE,oBAAA;AAJF;;AAMA;EACE,iBAAA;AAHF;;AAKA;EACE,iBAAA;AAFF;;AAIA;EACE,cAAA;AADF;;AAGA;EACE,QAAA;AAAF;;AAEA;EACE,QAAA;AACF;;AACA;EACE,UAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,WAAA;AAMF;;AAJA;EACE,eAAA;AAOF;;AALA;EACE,cAAA;AAQF;;AANA;EACE,gBAAA;AASF;;AAPA;EACE,gBAAA;AAUF;;AARA;EACE,gBAAA;AAWF;;AATA;EACE,aAAA;EACA,sBAAA;AAYF;;AATA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;AAYF;;AAVA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAaF;;AAVA;EACE,yDAAA;EACA,WAAA;AAaF;;AATA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAYF;;AAVA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,kDAAA;EACA,mBAAA;EACA,SAAA;AAaF;;AAXA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,YAAA;EACA,aAAA;AAcF;;AAZA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,iDAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAcF;;AAZA;EACE,iBAAA;AAeF;;AAbA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;AAgBF;;AAdA;EACE,SAAA;AAiBF;;AAfA;EACE,gBAAA;EACA,sBAAA;AAkBF;;AAbA;EACE,UAAA;EACA,gBAAA;AAgBF;;AAbA;EACE,gBAAA;AAgBF;;AAbA;EACE,kBAAA;AAgBF;;AAbA;EACE,kBAAA;AAgBF;;AAbA;EACE,gBAAA;AAgBF;;AAbA;EACE,gBAAA;AAgBF;;AAbA;EACE,kBAAA;AAgBF;;AAbA;EACE,gBAAA;AAgBF;;AAdA;EACE,WAAA;AAiBF;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAiBF;;AAdA;EACE,cAAA;AAiBF;;AAdA;EACE,iBAAA;AAiBF;AAfE;EACE,iBAAA;AAiBJ;AAfE;EACE,iBAAA;AAiBJ;AAfE;EACE,iBAAA;AAiBJ;;AAdA;EACE,kBAAA;AAiBF;AAfE;EACE,kBAAA;AAiBJ;AAfE;EACE,kBAAA;AAiBJ;AAfE;EACE,kBAAA;AAiBJ;;AAbA;EACE,gBAAA;AAgBF;;AAbA;EACE,aAAA;AAgBF;;AAdA;EACE,iBAAA;AAiBF;;AAfA;EACE,iDAAA;AAkBF;;AAfE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AAkBJ;AAhBE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,SAAA;AAkBJ;;AARA;EACE,YAAA;EACA,eAAA;AAWF;;AATA;EACE,gBAAA;AAYF;AAVE;EACE,sBAAA;AAYJ;;AARA;EACE,YAAA;AAWF;;AATA;EACE,kBAAA;AAYF","sourcesContent":[".appIcon {\n  width: 1.5em;\n  height: 1.5em;\n}\n.control__btn {\n  position: absolute;\n  bottom: 0.5em;\n  // margin-top: 1em;\n  right: 1.5em;\n}\n.btn_container {\n  display: flex;\n  gap: 2em;\n  margin-bottom: 1em;\n  &.left {\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n.two-column-page__container {\n  // padding: 0 1.5em;\n  height: 100%;\n  // calc(100% - 2em);\n  // padding-top: 10px;\n  // max-width: 1900px;\n  display: flex;\n  // justify-content: stretch;\n  position: relative;\n  width: 100%;\n  // min-width: 1012px;\n  // justify-content: center;\n  .right-side {\n    max-width: 50%;\n    padding-left: 1%;\n    // display: flex;\n    // flex-direction: column;\n    // justify-content: stretch;\n    // height: 100%;\n\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n    // height: 100%;\n    // height: 99vh;\n    // height: 90vh;\n    // height: var(--app-height);\n  }\n  .left-side {\n    padding-right: 1%;\n    border-right: 1px solid#426ca62a;\n    max-width: 100%;\n\n    // display: flex;\n    // flex-direction: column;\n    // justify-content: stretch;\n    // height: 100%;\n\n    // height: 99vh;\n    // height: var(--app-height);\n\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  .save_btns {\n    color: #567db8;\n    button {\n      margin-top: 10px;\n      margin-left: 10px;\n      font-weight: 400;\n      color: #567db8;\n      border: 0;\n      &:disabled {\n        color: #567db869;\n        background: #dae1ec8a;\n        cursor: default;\n      }\n    }\n  }\n  hr {\n    border-top: 0.01px solid #2d6dc757;\n    width: 100%;\n    margin-left: 0;\n    color: #426ba6;\n  }\n}\n.right-side-btn {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin: 10px 0;\n}\n\n//label\n.label {\n  align-items: center;\n  &_thin {\n    color: #88a5cf;\n    font-size: 12px;\n    font-style: italic;\n    font-weight: 400;\n    margin-right: 5px;\n  }\n  &.underline {\n    text-decoration: underline;\n  }\n  &.autolabel {\n    width: min-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n  }\n}\n.autolabel {\n  label {\n    width: min-content;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: keep-all;\n    white-space: nowrap; /* Запретить перенос текста по строчке */\n    display: inline-block;\n    width: auto;\n  }\n}\n.row {\n  display: flex;\n  align-items: baseline;\n}\n\n.labelWrap {\n  white-space: nowrap;\n}\n\n.tac {\n  text-align: center;\n}\n\n.project_form {\n  height: 100%;\n}\n\n.list_container {\n  width: 100%;\n  height: 120px;\n  overflow-x: hidden;\n  background: #ffffff;\n  margin-bottom: 5px;\n\n  border: #426ca681;\n}\n\n//grid\n.grid2_3 {\n  display: grid;\n  grid-template: 1fr 1fr / 1fr 1fr 1fr 1fr;\n}\n.grid2_5 {\n  display: grid;\n  grid-template: 0fr 0fr / 1fr 1fr 1fr 1fr auto;\n  width: 100%;\n  column-gap: 10px;\n}\n/// flex\n\n.fdr {\n  display: flex;\n  flex-direction: row;\n}\n.flex_form {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex_container {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.fc {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.hw100 {\n  height: 100%;\n  width: 100%;\n  flex-grow: 1;\n}\n\n.fc {\n  display: flex;\n  align-items: center;\n  // justify-content: space-between;\n\n  .fi50 {\n    flex-basis: 50%;\n  }\n  .fi60 {\n    flex-basis: 60%;\n  }\n  .fi70 {\n    flex-basis: 70%;\n  }\n}\n\n.fcc {\n  display: flex;\n  // flex-wrap: nowrap;\n  flex-direction: row;\n  align-items: center;\n}\n.nowrap {\n  flex-wrap: nowrap;\n}\n.space-between {\n  justify-content: space-between;\n}\n.jcsb {\n  justify-content: space-between;\n}\n.jcsa {\n  justify-content: space-around;\n}\n.jcc {\n  justify-content: center;\n}\n.jcfe {\n  justify-content: flex-end;\n}\n.jcfs {\n  justify-content: flex-start;\n}\n.aic {\n  align-items: center;\n}\n.aife {\n  align-items: flex-end;\n}\n.aist {\n  align-items: flex-start;\n}\n.aibl {\n  align-items: baseline;\n}\n.aistr {\n  align-items: stretch;\n}\n.fd {\n  flex-direction: column;\n}\n\n.gap {\n  gap: 1rem;\n}\n.gap2x {\n  gap: 2rem;\n}\n.gap5 {\n  gap: 5px;\n}\n.halfBasis {\n  flex-basis: 50%;\n}\n.mba {\n  margin-bottom: auto;\n}\n.mb {\n  margin-bottom: 1rem;\n}\n.mb2x {\n  margin-bottom: 2rem;\n}\n.pb {\n  padding-bottom: 1rem;\n}\n.pt {\n  padding-top: 1rem;\n}\n.pt2x {\n  padding-top: 2rem;\n}\n.noShrink {\n  flex-shrink: 0;\n}\n.g2 {\n  gap: 2em;\n}\n.g1 {\n  gap: 1em;\n}\n.g15 {\n  gap: 1.5em;\n}\n.fGrow {\n  flex-grow: 1;\n}\n.fShrink {\n  flex-shrink: 2;\n}\n\n.h100 {\n  height: 100%;\n}\n.hmax100 {\n  max-height: 100%;\n}\n.w100 {\n  width: 100%;\n}\n.wmax100 {\n  max-width: 100%;\n}\n.overflowAuto {\n  overflow: auto;\n}\n.overflowX {\n  overflow-x: auto;\n}\n.overflowY {\n  overflow-y: auto;\n}\n.overflowHidden {\n  overflow: hidden;\n}\n.fcCol {\n  display: flex;\n  flex-direction: column;\n}\n///////////\n.page_container {\n  padding: 0 1%;\n  padding-top: 5px;\n  height: 100%;\n}\n.form_wrapper {\n  height: 100%;\n  width: 100%;\n  min-width: 100%;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-x: visible;\n  position: relative;\n}\n\n.border_bottom_container {\n  border-bottom: 1px solid #426ca681;\n  width: 100%;\n}\n///////////\n\n.imgPreview {\n  width: 100%;\n  min-width: 600px;\n  height: 100%;\n  padding: 1em 2em;\n  padding-bottom: 3em;\n  box-sizing: border-box;\n}\n.previewBox {\n  width: 100%;\n  height: auto;\n  min-height: 250px;\n  max-width: 920px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding: 20px 20px;\n  box-sizing: border-box;\n  border: dashed 3px #426ca65e;\n  border-radius: 10px;\n  gap: 10px;\n}\n.previewBoxItem {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  object-fit: contain;\n  border: 1px solid #426ca65e;\n  width: 200px;\n  height: 200px;\n}\n.previewBoxItem__del {\n  position: absolute;\n  top: 0;\n  right: -4px;\n  border: 1px solid #426ca65e;\n\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background-color: aliceblue;\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: 300;\n  margin-top: -5px;\n  cursor: pointer;\n}\n.previewBoxItem img {\n  object-fit: cover;\n}\n.imgPreview__buttons {\n  position: fixed;\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  bottom: 10px;\n  right: 5px;\n}\n.img-adding {\n  border: 0;\n}\n.cropper_container {\n  padding: 1em 2em;\n  box-sizing: border-box;\n}\n/////\n\n//list\n.list {\n  padding: 0;\n  list-style: none;\n}\n\n.hideOverflow {\n  overflow: hidden;\n}\n\n.scrollOverflow {\n  overflow-y: scroll;\n}\n\n.centeredText {\n  text-align: center;\n}\n\n.toBottom {\n  margin-top: auto;\n}\n\n.mt {\n  margin-top: 1rem;\n}\n\n.pl {\n  padding-left: 1rem;\n}\n\n.scrollY {\n  overflow-y: auto;\n}\n.fullWidth {\n  width: 100%;\n}\n\n.zindex {\n  z-index: 10000;\n}\n\n.hiddenEl {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  clip: rect(0 0 0 0);\n}\n\n.db {\n  display: block;\n}\n\n.ml {\n  margin-left: 1rem;\n\n  &2x {\n    margin-left: 2rem;\n  }\n  &5x {\n    margin-left: 5rem;\n  }\n  &a {\n    margin-left: auto;\n  }\n}\n.mr {\n  margin-right: 1rem;\n\n  &2x {\n    margin-right: 2rem;\n  }\n  &5x {\n    margin-right: 5rem;\n  }\n  &a {\n    margin-right: auto;\n  }\n}\n\n.mta {\n  margin-top: auto;\n}\n\n.dg {\n  display: grid;\n}\n.bold {\n  font-weight: bold;\n}\n.bordered {\n  border: 1px solid #426ca65e;\n}\n.inputNoArrows {\n  &::-webkit-outer-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n  &::-webkit-inner-spin-button {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: textfield;\n    margin: 0;\n  }\n}\n\n.qrCodeImg {\n  // filter: blur(3px);\n  // opacity: 0.5;\n  // <<<<<<< develop\n}\n\n.navItemDisabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.largeModal {\n  max-height: 90vh;\n\n  .modal_form__child {\n    flex-direction: column;\n  }\n}\n\n.padding5 {\n  padding: 5px;\n}\n.br {\n  border-radius: 3px;\n  // =======\n  // >>>>>>> prod\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
